import {
  Box,
  Button,
  Flex,
  Image,
  Input,
  Stack,
  Text,
  Textarea,
  useColorModeValue,
} from "@chakra-ui/react";
import { MdOutlineAttachFile } from "react-icons/md";
import { AiOutlineSend } from "react-icons/ai";
import { useDeferredValue, useEffect, useRef, useState } from "react";
import { db, sendMessage } from "../../service/firebase";

import EmojiSelector from "../../components/EmojiSelector";
import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import useSmallScreen from "../../components/useSmallScreen";
import { IoMdLink } from "react-icons/io";
import thelogo from "../../assets/thelogo.png";

function MessageBox({
  width,
  user,
  selectedChat,
  handleSendMsg,
  handleSendFile,
  setImgPreview,
}) {
  const inputBg = useColorModeValue("#fff", "#030c1d");
  const [message, setMessage] = useState("");
  const [img, setImg] = useState("");
  const [file, setFile] = useState();
  const [metaTags, setMetaTags] = useState([]); //added

  const deferredInput = useDeferredValue(message);
  const imgRef = useRef();
  const [disabled, setDisabled] = useState(true);
  const [smallScreen] = useSmallScreen();
  const chatBg = useColorModeValue("#f9fafc", "#030c1b");
  const mobileChatBoxStyles = {
    position: " fixed",
    bottom: "6vh",
    left: 0,
    right: 0,
    width: "100%",
    background: chatBg,
    height: " 100px",
    borderRadius: "unset",
    zIndex: "9999",
  };

  // send button validation
  useEffect(() => {
    if (!selectedChat) {
      setDisabled(true);
    }

    if (message || img) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [img, selectedChat, message]);

  const handleSendMessage = async () => {
    await sendMessage(selectedChat, user, message, img, setImg);
    setMessage("");
  };

  const handleInputChange = (event) => {
    const newText = event.target.value;
    setMessage(newText);
    extractMetaTags(newText);
  };

  const sendChat = (event) => {
    event.preventDefault();
    if (message.length > 0) {
      handleSendMsg(message);
      setMessage("");
    }
  };

  const extractMetaTags = async (text) => {
    const urlRegex = /(https?:\/\/[^\s/$.?#].[^\s]*)/gi; // Matches both http and https
    const urls = text.match(urlRegex);
  
    if (urls && urls.length > 0) {
      try {
        // Extract the first URL from the array
        const url = urls[0];
  
        // Fetch the URL content
        const response = await fetch(url);
        const html = await response.text();
  
        // Extract the title and description from the HTML
        const titleMatch = html.match(/<title[^>]*>([^<]+)<\/title>/i);
        const descriptionMatch = html.match(/<meta name="description" content="([^"]+)"/i);
  
        // Get the domain from the URL
        const domain = new URL(url);
        const href = domain?.href;
        const faviconServiceUrl = `https://s2.googleusercontent.com/s2/favicons?domain=${href}`;
        const faviconResponse = await fetch(faviconServiceUrl);
  
        if (faviconResponse.ok) {
          const faviconData = await faviconResponse.json();
          if (faviconData.favicon) {
            setMetaTags([
              {
                url,
                title: titleMatch ? titleMatch[1] : '',
                description: descriptionMatch ? descriptionMatch[1] : '',
                favicon: faviconData.favicon,
              },
            ]);
          } else {
            setMetaTags([
              {
                url,
                title: titleMatch ? titleMatch[1] : '',
                description: descriptionMatch ? descriptionMatch[1] : '',
              },
            ]);
          }
        } else {
          // Handle the case where the favicon service fails
          console.error(`Error fetching favicon for URL: ${url}`);
        }
      } catch (error) {
        console.error(`Error fetching URL: ${urls[0]}`, error);
      }
    } else {
      setMetaTags([]);
    }
  };
  
  //extractFavicon
  const extractFavicon = async (faviconUrl) => {
    try {
      const faviconServiceUrl = `https://s2.googleusercontent.com/s2/favicons?domain=${faviconUrl}`;
      const faviconResponse = await fetch(faviconServiceUrl, { redirect: 'follow' });
  
      if (faviconResponse.ok) {
        return faviconResponse;
      } else {
        console.error(`Error fetching favicon for URL: ${faviconUrl}`);
        return false;
      }
    } catch (error) {
      console.error(`Error fetching favicon for URL: ${faviconUrl}`, error);
      return false;
    }
  }

  // convert file to a base64 url
  const readURL = (file) => {
    return new Promise((res, rej) => {
      const reader = new FileReader();
      reader.onload = (e) => res(e.target.result);
      reader.onerror = (e) => rej(e);
      reader.readAsDataURL(file);
    });
  };
  
  const selectFile = async (e) => {
    const selectedFile = e.target.files[0];

    // Read the selected file and display a preview
    // readURL(selectedFile)
    // .then((dataURL) => {
    //   // Set the preview image in your component's state
    //   setImgPreview(dataURL);
    // })
    // .catch((error) => {
    //   console.error('Error reading the file:', error);
    // });

    const formData = new FormData();
    formData.append("file", selectedFile);

    // Move the console.log here, after appending the file
    await handleSendFile(selectedFile, e)
    setMessage("");
  };

  function onClick(emojiData, event) {
    setMessage((prev) => `${prev} ${emojiData.emoji}`);
  }

  // listen for user typing and send status
  useEffect(() => {
    if (!user?.username) return;
    if (!selectedChat) return;
    if (!deferredInput) return;
    const sendTypeStatus = async () => {
      const typingStatusExist = await getDoc(
        doc(db, "typing-status", selectedChat)
      );

      if (deferredInput?.length < 3) {
        if (typingStatusExist?.exists()) {
          await updateDoc(doc(db, "typing-status", selectedChat), {
            typing: false,
          });
        }

        return;
      }

      if (typingStatusExist?.exists()) {
        await updateDoc(doc(db, "typing-status", selectedChat), {
          typing: true,
          user: user?.username,
        });
      } else {
        await setDoc(doc(db, "typing-status", selectedChat), {
          typing: true,
          user: user?.username,
        });
      }
    };
    sendTypeStatus();
    //eslint-disable-next-line
  }, [deferredInput]);

  return (
    <>
    {metaTags?.map((tag, index) => (
      <Flex key={index} alignItems="center" gap={"10px"}>
        {tag?.favicon && <Box 
          boxShadow={"2px 2px 5px #0000004d"}
          borderRadius="5px">
        <Image
          w="40px"
          h="40px"
          objectFit={"cover"}
          borderRadius={"5px"}
          alt="Favicon"
          //src={tag.favicon}
          src={tag.favicon}
        />
        </Box>}
        <Box>
          
          {tag?.title && <Text fontSize={"14px"}>Title: {tag.title}</Text>}
          {tag?.description && <Text fontSize={"10px"}>Title: {tag.description}</Text>}
      
        </Box>
      </Flex>
    ))}
      <div style={{ display:"none" }}>
        {metaTags?.map((tag, index) => (
          <div key={index}>
            <p>URL: {tag.url}</p>
            {tag.title && <p>Title: {tag.title}</p>}
            {tag.description && <p>Description: {tag.description}</p>}
            {tag.favicon && <img src={tag.favicon} alt="Favicon" />}
          </div>
        ))}
      </div>
      <Stack
        position={["absolute", "fixed"]}
        bottom={["0px", "30px"]}
        w={["100%", width - 30]}
        direction="row"
        alignItems={"center"}
        bg={inputBg}
        borderRadius={"20px"}
        p="5px"
        {...(smallScreen ? mobileChatBoxStyles : {})}
      >
        
        <style>
          {`
        /* Hide scrollbar for Chrome, Safari and Opera */
        .textarea-scroll::-webkit-scrollbar {
          display: none;
        }

        /* Hide scrollbar for IE, Edge and Firefox */
        .textarea-scroll {
          -ms-overflow-style: none;  /* IE and Edge */
          scrollbar-width: none;  /* Firefox */
        }
        `}
        </style>
      
        <Textarea
          className="scroll-container textarea-scroll"
          rows="1"
          size={"sm"}
          style={{ resize: "none" }}
          placeholder="Enter your message here"
          type="text"
          value={message}
          bg={inputBg}
          overflow=""
          //onChange={(e) => setMessage(e.target.value)}
          onChange={handleInputChange}
          border="none"
        />
        <Stack
          direction={"row"}
          alignItems="center"
          ml="-80px"
          mt="20px"
          bg={inputBg}
        >
          <EmojiSelector onClick={onClick} />
          <Input
            display={"none"}
            type="file"
            accept="image/jpg, image/jpeg, image/png"
            ref={imgRef}
            onChange={selectFile}
          />

          <MdOutlineAttachFile
            cursor={"pointer"}
            color="#AFBBC6"
            fontSize={"1.5em"}
            onClick={() => imgRef.current?.click()}
          />
          <Button
            bg="#50BB69"
            color="#fff"
            p="3px"
            borderRadius={"50%"}
            onClick={sendChat}
            isDisabled={disabled}
          >
            <AiOutlineSend cursor="pointer" fontSize={".9em"} />
          </Button>
        </Stack>
      </Stack>
    </>
    
  );
}

export default MessageBox;
